module.exports = __webpack_public_path__ + "img/jfrog_gray_logo.aa2b51de.png";